import {
    RxDbPersistenceManager,
    type PersistenceManager
} from '@tadpoles/persistence'

const defaultDatabaseNamePrefix = 'tadpoles-family'

export function createFamilyPersistenceManager(): PersistenceManager {
    return new RxDbPersistenceManager({
        databaseNamePrefix: defaultDatabaseNamePrefix
    })
}
